import { render } from "./RejectedDowngrade.vue?vue&type=template&id=4081456a"
import script from "./RejectedDowngrade.vue?vue&type=script&lang=js"
export * from "./RejectedDowngrade.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__